export const selectLoginParams = state => state.loginParams.parameters;
export const selectTgAuthParam = state => state.loginParams.parameters.tgauth;